import { createRootRoute, Outlet, useLocation } from '@tanstack/react-router';
import { VideoGrain } from '@/components/visuals/VideoGrain';
import { api, redirectBasedOnState } from '@/api';
import { useDeviceId, useGameState, usePlayerState, usePlayLocation, useStore } from '@/engine/store';
import { Button } from 'ht-sdk/react';
import { ChevronDown, LogOut } from 'lucide-react';
import { useState } from 'react';

export const Route = createRootRoute({
	component: RootLayout,
	beforeLoad: redirectBasedOnState,
});

function RootLayout() {
	const loc = useLocation();
	const damage = useStore((s) => s.gameState?.systemDamage);

	switch (loc.pathname) {
		case '/game':
		case '/observe-game':
			return (
				<VideoGrain percentage={damage}>
					<Outlet />
				</VideoGrain>
			);
		case '/set-player':
		case '/no-game':
			return (
				<>
					<DebugMenu />
					<Outlet />
				</>
			);
		default:
			return <Outlet />;
	}
}

export function DebugMenu() {
	const [open, setOpen] = useState(false);
	const location = usePlayLocation();
	const gameState = useGameState();
	const player = usePlayerState();
	const deviceId = useDeviceId();

	return (
		<div
			className={`absolute top-0 left-0 z-9999 flex flex-col items-center overflow-hidden rounded-br-4xl bg-black pb-2 transition-all ${open ? 'h-52 w-32' : 'size-10'}`}
		>
			<Button
				mode="transparent"
				className="absolute -top-2 -left-3 cursor-pointer rounded-br-full text-left text-white hover:bg-transparent"
				onClick={() => setOpen(!open)}
			>
				<ChevronDown className={`${open ? 'rotate-180' : 'rotate-0'} transition-transform`} />
			</Button>
			{open && (
				<>
					<div className="w-full cursor-pointer" onClick={() => setOpen(!open)}>
						<p className="absolute top-1 right-2">Menu</p>
						<hr className="mt-8 w-full" />
					</div>
					<div className="relative size-full px-2 break-all">
						<p className="text-xs text-gray-300">{gameState?.sessionId}</p>
						<p className="text-gray-100">Status: {gameState?.status}</p>
						<hr className="py-1" />
						<p className="rounded-full bg-gray-700 text-center text-gray-100">{location?.code}</p>
						<p className="pb-1 text-center text-gray-100">{location?.name}</p>
						<hr />
						<button
							className="absolute bottom-0 flex w-full flex-row gap-2 text-white hover:text-red-500"
							onClick={async () => {
								if (location)
									await api.eventLogCreate({
										eventType: 'LEAVE_LOCATION',
										playerId: player.id,
										sessionId: gameState?.sessionId,
										data: { locationId: location.id, deviceId: deviceId },
									});
								useStore.getState().leaveLocation();
							}}
						>
							<LogOut />
							Exit game
						</button>
					</div>
				</>
			)}
		</div>
	);
}
